import { useState } from "react"
import { bool, func, shape, string } from "prop-types"
import { TextInput } from "@planningcenter/doxy-web"

import FieldLabel from "../FieldLabel"

TextField.propTypes = {
  field: shape({
    attributes: shape({
      description: string,
      label: string.isRequired,
      placeholder: string,
      required: bool.isRequired,
    }),
    id: string.isRequired,
  }),
  onChange: func.isRequired,
}

export default function TextField({ field, onChange }) {
  const [value, setValue] = useState("")
  const {
    attributes: { description, label, placeholder, required },
    id,
  } = field
  const inputId = `field_${id}_value`

  const handleChange = ({ target: { value } }) => {
    setValue(value)
    onChange(value, id)
  }

  return (
    <>
      <FieldLabel text={label} {...{ required }}>
        {label}
      </FieldLabel>
      <p style={{ whiteSpace: "pre-line" }}>{description}</p>
      <TextInput
        id={inputId}
        onChange={handleChange}
        {...{ placeholder, required, value }}
      />
    </>
  )
}
